import { render } from "./OpenApplications.vue?vue&type=template&id=36d35c00&scoped=true"
import script from "./OpenApplications.vue?vue&type=script&lang=js"
export * from "./OpenApplications.vue?vue&type=script&lang=js"

import "./OpenApplications.vue?vue&type=style&index=0&id=36d35c00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d35c00"]])

export default __exports__